import { UiText } from 'znanie-uikit';

import css from './MaterialExtension.module.scss';

interface IMaterialExtension {
  fileName: string;
}

export default function MaterialExtension({ fileName }: IMaterialExtension) {
  const extension = fileName.split('.').pop()?.toLocaleUpperCase();

  return (
    <UiText className={css.extension} as="span" color="white">
      {extension}
    </UiText>
  );
}
